export const ACTION_MENU_TYPE = {
  ACCEPT_PUBLISHED: 'ACCEPT_PUBLISHED',
  ACCEPT_DRAFT: 'ACCEPT_DRAFT',
  PUBLISH: 'PUBLISH',
  REJECT: 'REJECT',
};
